import { plainAxiosInstance } from "../axios";

class UserService {
  getUser() {
    return plainAxiosInstance.get("/user");
  }

  forgotPassword(email) {
    return plainAxiosInstance.get("/user/password_resets/new", { params: { email } });
  }
}

export default new UserService();
